var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctotal bgps flex"},_vm._l((_vm.titlearr),function(i,j){return _c('div',{key:j,staticClass:"f1 flex ac",staticStyle:{"text-indent":"0.5rem"},style:(`color:${ i.select == 1 ? 'white' : ''}`),on:{"click":function($event){return _vm.tabclick(j)}}},[_vm._v(_vm._s(i.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }